import EventDetail from './detail';

export default EventDetail;